import script from "./ExportVideo.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExportVideo.vue?vue&type=script&setup=true&lang=ts"

import "./ExportVideo.vue?vue&type=style&index=0&id=c387775a&lang=less"

const __exports__ = script;

export default __exports__